export default __webpack_public_path__ + "static/media/videosIcon.21a96dd4.svg";